import React, { useContext } from 'react'
import { DataSupportPartnerContext } from '../types'
import { InputElement } from '../../../../HtmlComponents/InputElement'

const InputsSupportPartner = () => {
  const {
    amount, setAmount,
    createdAt, setCreatedAt
  } = useContext(DataSupportPartnerContext)
  return (
    <>
      <InputElement name='Montant' value={amount} setValue={setAmount}/>
      <InputElement type='date' name='Date' value={createdAt} setValue={setCreatedAt}/>
    </>
  )
}

export default InputsSupportPartner